import { ODSColumn } from '@telekom-ods/react-ui-kit';
import { Outlet } from 'react-router';

import Footer from './Footer';

const PageContent = () => {
  return (
    <ODSColumn
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      {/* Scrollable content */}
      <ODSColumn
        className='page-content-scrollable'
        style={{
          flexGrow: 1,
          overflowY: 'auto',
          height: '100vh',
          paddingBottom: 0,
        }}
      >
        <ODSColumn
          style={{
            maxWidth: '1500px',
            margin: '0 auto',
            display: 'block',
            padding: '1rem',
            width: '100%',
          }}
        >
          <Outlet />
        </ODSColumn>
        {/* Footer */}
        <ODSColumn
          style={{
            position: 'static',
            display: 'flex',
            justifyContent: 'end',
            marginTop: 'auto',
            zIndex: 5,
          }}
        >
          <Footer />
        </ODSColumn>
      </ODSColumn>
    </ODSColumn>
  );
};

export default PageContent;
